import { useState } from 'react';

import { FontSize, actions, salesMode } from 'commons';
import { ButtonGroup, Text, UberPickupCode } from 'components';
import { ConsignmentDetails } from 'types';

import { CarrierForm, CustomerForm } from './components';
import * as S from './styles';

interface Props {
  consignmentDetails: ConsignmentDetails;
}

const collectTypes = {
  carrier: 'carrier',
  customer: 'customer',
};

export function CollectForm({ consignmentDetails }: Props) {
  const { isSuperExpress, pinCodes } = consignmentDetails;

  const initialCollectType =
    consignmentDetails.salesMode === salesMode.pickup
      ? collectTypes.customer
      : collectTypes.carrier;

  const [collectType, setCollectType] = useState(initialCollectType);

  const action: string = (() => {
    if (initialCollectType === collectTypes.customer) {
      return actions.pickUp;
    }

    if (collectType === collectTypes.customer) {
      return actions.pickUpStoreShipping;
    } else {
      return actions.storeShipping;
    }
  })();

  const collectTypeOptions = [
    { label: 'Retirado pelo Transportador', value: collectTypes.carrier },
    { label: 'Retirado pela Cliente', value: collectTypes.customer },
  ];

  const shouldShowCollectTypeSelector =
    initialCollectType === collectTypes.carrier && !isSuperExpress;

  return (
    <S.Main>
      <S.TittleWrapper>
        <Text size={FontSize.font12}>
          Deixe o pedido pronto para ser retirado e preencha abaixo os dados de
          quem está realizando a retirada em loja:
        </Text>
      </S.TittleWrapper>

      {isSuperExpress && (
        <UberPickupCode
          title="Código Uber de retirada"
          code={pinCodes.superExpressPickupCode}
          description={
            <>
              Informe esse código para o entregador e{' '}
              <span className="font-bold">
                confira o início da viagem no aplicativo dele
              </span>
            </>
          }
        />
      )}

      {shouldShowCollectTypeSelector && (
        <ButtonGroup options={collectTypeOptions} onChange={setCollectType} />
      )}

      {collectType === collectTypes.carrier ? (
        <CarrierForm consignmentDetails={consignmentDetails} action={action} />
      ) : (
        <CustomerForm consignmentDetails={consignmentDetails} action={action} />
      )}
    </S.Main>
  );
}
